import React, { useState, useEffect } from "react";
import { Row, Col, Card, Typography, Progress } from "antd";
import {
  UsergroupAddOutlined,
  BookOutlined,
  EnvironmentOutlined,
  CloudOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import axiosInstance from "../services/axios";
import EmptyState from './EmptyState';
import badgeIcon from "../assets/icons/badge.png";
import powerIcon from "../assets/icons/power.png";
import trophyIcon from "../assets/icons/trophy.png";
import waterIcon from "../assets/icons/water.png";
import roadIcon from "../assets/icons/road.png";
import solarIcon from "../assets/icons/solar.png";
import peopleIcon from "../assets/icons/group.svg";
import familyIcon from "../assets/icons/family.svg";
import maleIcon from "../assets/icons/male.svg";
import femaleIcon from "../assets/icons/female.svg";
import literacyIcon from "../assets/icons/literacy.svg";
import schoolIcon from "../assets/icons/Zilla School.svg";
import villageIcon from "../assets/icons/village.svg";
import societyIcon from "../assets/icons/members.svg";
import healthIcon from "../assets/icons/child_care.svg";
import industryIcon from "../assets/icons/local_library.svg";

import "./Keyfigure.css";

import locationIcon from "../assets/icons/location_on.svg";
import AnimatedCounter from "./AnimatedCounter";
import Heading from "./Heading";

const { Title, Text } = Typography;

// --- The Main Component ---
const KeyFiguresUi = ({ className = "" }) => {
  const { t, i18n } = useTranslation();

  // English key figures data
  // const keyFiguresDataEn = [
  //   {
  //     value: "12,458",
  //     label: "Population",
  //     icon: groupIcon,
  //     styleContent: "linear-gradient(135deg, #2B7FFF 0%, #002371 100%)",
  //     bgColor: "#e6f7ff",
  //   },
  //   {
  //     value: "87.5%",
  //     label: "Literacy Rate",
  //     icon: contactIcon,
  //     bgColor: "#f6ffed",
  //     styleContent: "linear-gradient(135deg, #00C950 0%, #006D29 100%)",
  //   },
  //   {
  //     value: "15",
  //     label: "Divisions",
  //     icon: locationIcon,
  //     bgColor: "#fff2e8",
  //     styleContent: "linear-gradient(135deg, #FF6900 0%, #F54900 100%)",
  //   },
  //   {
  //     value: "15",
  //     label: "Wards",
  //     icon: icon,
  //     bgColor: "#fff2e8",
  //     styleContent: "linear-gradient(135deg, #00B8DB 0%, #004A5D 100%)",
  //   },
  // ];

  // // Marathi key figures data
  // const keyFiguresDataMr = [
  //   {
  //     value: "१२,४५८",
  //     label: "लोकसंख्या",
  //     icon: groupIcon,
  //     styleContent: "linear-gradient(135deg, #2B7FFF 0%, #002371 100%)",
  //     bgColor: "#e6f7ff",
  //   },
  //   {
  //     value: "८७.५%",
  //     label: "साक्षरता दर",
  //     icon: contactIcon,
  //     bgColor: "#f6ffed",
  //     styleContent: "linear-gradient(135deg, #00C950 0%, #006D29 100%)",
  //   },
  //   {
  //     value: "१५",
  //     label: "प्रभाग",
  //     icon: locationIcon,
  //     bgColor: "#fff2e8",
  //     styleContent: "linear-gradient(135deg, #FF6900 0%, #F54900 100%)",
  //   },
  //   {
  //     value: "१५",
  //     label: "प्रभाग",
  //     icon: icon,
  //     bgColor: "#fff2e8",
  //     styleContent: "linear-gradient(135deg, #00B8DB 0%, #004A5D 100%)",
  //   },
  // ];

  // const keyFiguresDataMr1 = [
  //   {
  //     value: "१२,४५८",
  //     label: "लोकसंख्या",
  //     icon: groupIcon,
  //     styleContent: "linear-gradient(135deg, #2B7FFF 0%, #002371 100%)",
  //     bgColor: "#e6f7ff",
  //   },
  //   {
  //     value: "८७.५%",
  //     label: "साक्षरता दर",
  //     icon: contactIcon,
  //     bgColor: "#f6ffed",
  //     styleContent: "linear-gradient(135deg, #00C950 0%, #006D29 100%)",
  //   },
  //   {
  //     value: "१५",
  //     label: "प्रभाग",
  //     icon: locationIcon,
  //     bgColor: "#fff2e8",
  //     styleContent: "linear-gradient(135deg, #FF6900 0%, #F54900 100%)",
  //   },
  //   {
  //     value: "१५",
  //     label: "प्रभाग",
  //     icon: locationIcon,
  //     bgColor: "#fff2e8",
  //     styleContent: "linear-gradient(135deg, #FF6900 0%, #F54900 100%)",
  //   },
  //   {
  //     value: "१५",
  //     label: "प्रभाग",
  //     icon: locationIcon,
  //     bgColor: "#fff2e8",
  //     styleContent: "linear-gradient(135deg, #FF6900 0%, #F54900 100%)",
  //   },
  //   {
  //     value: "१५",
  //     label: "प्रभाग",
  //     icon: icon,
  //     bgColor: "#fff2e8",
  //     styleContent: "linear-gradient(135deg, #00B8DB 0%, #004A5D 100%)",
  //   },
  //   {
  //     value: "१५",
  //     label: "प्रभाग",
  //     icon: locationIcon,
  //     bgColor: "#fff2e8",
  //     styleContent: "linear-gradient(135deg, #FF6900 0%, #F54900 100%)",
  //   },
  // ];
  // English progress data
  // const progressDataEn = [
  //   { label: "Cleanliness", percent: 90, strokeColor: "var(--color-primary)" },
  //   { label: "Water Connection", percent: 80, strokeColor: "var(--color-primary)" },
  //   { label: "Complaint Resolution", percent: 100, strokeColor: "var(--color-primary)" },
  //   { label: "Tree Plantation", percent: 100, strokeColor: "var(--color-primary)" },
  //   { label: "Scheme Benefits", percent: 100, strokeColor: "var(--color-primary)" },
  // ];

  // // Marathi progress data
  // const progressDataMr = [
  //   { label: "स्वच्छता", percent: 90, strokeColor: "var(--color-primary)" },
  //   { label: "पाणी कनेक्शन", percent: 80, strokeColor: "var(--color-primary)" },
  //   { label: "तक्रार निराकरण", percent: 100, strokeColor: "var(--color-primary)" },
  //   { label: "वृक्षारोपण", percent: 100, strokeColor: "var(--color-primary)" },
  //   { label: "योजना लाभ", percent: 100, strokeColor: "var(--color-primary)" },
  // ];

  // English bottom info data
  const bottomInfoDataEn = [
    {
      value: "100% Power Supply",
      label: "",
      icon: (
        <img
          src={powerIcon}
          alt="Power"
          style={{ width: "51px", height: "51px" }}
        />
      ),
      iconBg: "#fffbe6",
    },
    {
      value: "Cleanliness First",
      label: "",
      icon: (
        <img
          src={trophyIcon}
          alt="Trophy"
          style={{ width: "51px", height: "51px" }}
        />
      ),
      iconBg: "#fff7e6",
    },
    {
      value: "500+ Water Connections",
      label: "",
      icon: (
        <img
          src={waterIcon}
          alt="Water"
          style={{ width: "51px", height: "51px" }}
        />
      ),
      iconBg: "#e6f7ff",
    },
    {
      value: "15 KM Roads",
      label: "",
      icon: (
        <img
          src={roadIcon}
          alt="Road"
          style={{ width: "51px", height: "51px" }}
        />
      ),
      iconBg: "#f6ffed",
    },
    {
      value: "Solar Energy Village",
      label: "",
      icon: (
        <img
          src={solarIcon}
          alt="Solar"
          style={{ width: "51px", height: "51px" }}
        />
      ),
      iconBg: "#fffbe6",
    },
  ];

  // Marathi bottom info data
  const bottomInfoDataMr = [
    {
      value: "१००% वीजपुरवठा",
      label: "",
      icon: (
        <img
          src={powerIcon}
          alt="Power"
          style={{ width: "51px", height: "51px" }}
        />
      ),
      iconBg: "#fffbe6",
    },
    {
      value: "स्वच्छता प्रथम",
      label: "",
      icon: (
        <img
          src={trophyIcon}
          alt="Trophy"
          style={{ width: "51px", height: "51px" }}
        />
      ),
      iconBg: "#fff7e6",
    },
    {
      value: "५००+ नळजोडणी",
      label: "",
      icon: (
        <img
          src={waterIcon}
          alt="Water"
          style={{ width: "51px", height: "51px" }}
        />
      ),
      iconBg: "#e6f7ff",
    },
    {
      value: "१५ किमी रस्ते",
      label: "",
      icon: (
        <img
          src={roadIcon}
          alt="Road"
          style={{ width: "51px", height: "51px" }}
        />
      ),
      iconBg: "#f6ffed",
    },
    {
      value: "सौर ऊर्जा गाव",
      label: "",
      icon: (
        <img
          src={solarIcon}
          alt="Solar"
          style={{ width: "51px", height: "51px" }}
        />
      ),
      iconBg: "#fffbe6",
    },
  ];

  // choose bottom info from language (these remain static lists)
  const bottomInfoData =
    i18n.language === "en" ? bottomInfoDataEn : bottomInfoDataMr;

  // Dynamic progress data from API
  const [progressData, setProgressData] = useState([]);

  useEffect(() => {
    let isMounted = true;
    const languageParam = i18n.language === "mr" ? "Marathi" : "English";

    const fetchProgressData = async () => {
      try {
        const resp = await axiosInstance.get("/progress/", { params: { language: languageParam } });

        if (!isMounted) return;

        let data = resp && resp.data ? resp.data : [];
        if (!Array.isArray(data)) {
          data = data.results || data.data || Object.values(data) || [];
        }

        if (!Array.isArray(data) || data.length === 0) {
          setProgressData([]);
          return;
        }

        // respect explicit ordering keys if provided; otherwise preserve API order
        const orderKeyCandidates = ["order", "id", "position"];
        const orderKey = orderKeyCandidates.find((k) =>
          data.every((item) => item[k] !== undefined)
        );
        const orderedData = orderKey
          ? [...data].sort(
            (a, b) => (Number(a[orderKey]) || 0) - (Number(b[orderKey]) || 0)
          )
          : data;

        const mapped = orderedData.map((d) => ({
          label: d.title || d.name || "-",
          percent:
            d.percentage !== undefined && d.percentage !== null
              ? d.percentage
              : 0,
          strokeColor: "var(--color-primary)",
        }));

        setProgressData(mapped);
      } catch (err) {
        console.error("Failed to load progress data:", err);
        if (isMounted) setProgressData([]);
      }
    };

    fetchProgressData();

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  // Dynamic key figures from API
  const [figures, setFigures] = useState([]);

  useEffect(() => {
    let isMounted = true;
    const languageParam = i18n.language === "mr" ? "Marathi" : "English";

    axiosInstance
      .get("/figures/", { params: { language: languageParam } })
      .then((resp) => {
        if (!isMounted) return;
        let data = resp && resp.data ? resp.data : [];
        if (!Array.isArray(data)) {
          data = data.results || data.data || Object.values(data) || [];
        }

        if (!Array.isArray(data) || data.length === 0) {
          setFigures([]);
          return;
        }

        // map API fields to UI shape
        const icons = [
          <UsergroupAddOutlined
            style={{ fontSize: "32px", color: "#fffdfeff" }}
          />,
          <BookOutlined style={{ fontSize: "32px", color: "#fffdfeff" }} />,
          <EnvironmentOutlined
            style={{ fontSize: "32px", color: "#fffdfeff" }}
          />,
          <CloudOutlined style={{ fontSize: "32px", color: "#fffdfeff" }} />,
        ];

        const defaultStyles = [
          { styleContent: "linear-gradient(135deg, #2B7FFF 0%, #002371 100%)", bgColor: "#e6f7ff" },
          { styleContent: "linear-gradient(135deg, #00C950 0%, #006D29 100%)", bgColor: "#f6ffed" },
          { styleContent: "linear-gradient(135deg, #FF6900 0%, #F54900 100%)", bgColor: "#fff2e8" },
          { styleContent: "linear-gradient(135deg, #00B8DB 0%, #004A5D 100%)", bgColor: "#fff2e8" },
        ];

        // Respect explicit ordering keys if provided; otherwise preserve API's returned order
        const orderKeyCandidates = ["order", "sort_order", "position"];
        const orderKey = orderKeyCandidates.find((k) =>
          data.every((item) => item[k] !== undefined)
        );
        const orderedData = orderKey
          ? [...data].sort(
            (a, b) => (Number(a[orderKey]) || 0) - (Number(b[orderKey]) || 0)
          )
          : data;

        const mapped = orderedData.map((d, idx) => {
          const s = defaultStyles[idx] || defaultStyles[idx % defaultStyles.length] || {};
          const rawValue =
            d.value !== undefined && d.value !== null ? String(d.value) : "-";
          const displayValue = d.unit
            ? d.unit.trim().startsWith("%")
              ? rawValue
              : rawValue
            : rawValue;
          return {
            value: displayValue,
            unit: d.unit || null,
            label: d.name || d.label || "-",
            icon: icons[idx] || icons[idx % icons.length] || null,
            styleContent:
              s.styleContent ||
              "linear-gradient(135deg, #2B7FFF 0%, #002371 100%)",
            bgColor: s.bgColor || "#e6f7ff",
          };
        });

        setFigures(mapped);
      })
      .catch((err) => {
        console.error("Failed to load key figures:", err);
        if (isMounted) setFigures([]);
      })
      .finally(() => {

      });

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  // State to track screen size
  const [isSmallScreen, setIsSmallScreen] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className={`dashboard-container keyfigure-section ${className}`.trim()}
    >
      <div className="">
        <Heading
          title={t("keyFigures.title") || "महत्वाचे आकडे"}
          variant={isSmallScreen ? "default" : "first"}
        />
      </div>

      <Row gutter={[16, 16]}>
        <Col xs={24} md={12}>
          <Row gutter={[16, 16]}>
            <Col xs={12} sm={12} md={12} lg={12}>
              <Card className="key-figure-card">
                <div
                  className="bottom-card-icon-wrapper"
                  style={{
                    background:
                      "linear-gradient(135deg, #00B8DB 0%, #004A5D 100%)",
                  }}
                >
                  <img loading="lazy" src={peopleIcon} alt="" />
                </div>

                <AnimatedCounter value={figures[0]?.value || 0} suffix="" />
                {/* <Title level={3} className="card-value">{figures[0]?.value}</Title> */}
                <Text>{figures[0]?.label}</Text>
              </Card>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12}>
              <Card className="key-figure-card">
                <div
                  className="bottom-card-icon-wrapper"
                  style={{
                    background:
                      "linear-gradient(135deg, #FF8027 0%, #F54900 100%)",
                  }}
                >
                  <img loading="lazy" src={familyIcon} alt="" />
                </div>
                <AnimatedCounter value={figures[1]?.value || 0} suffix="" />
                <Text>{figures[1]?.label}</Text>
              </Card>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12}>
              <Card className="key-figure-card">
                <div
                  className="bottom-card-icon-wrapper"
                  style={{
                    background:
                      "linear-gradient(135deg, #2B7FFF 0%, #002371 100%)",
                  }}
                >
                  <img loading="lazy" src={maleIcon} alt="" />
                </div>
                <AnimatedCounter value={figures[2]?.value || 0} suffix="" />

                <Text>{figures[2]?.label}</Text>
              </Card>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12}>
              <Card className="key-figure-card">
                <div
                  className="bottom-card-icon-wrapper"
                  style={{
                    background:
                      "linear-gradient(135deg, #FF53E8 0%, #84024A 100%)",
                  }}
                >
                  <img loading="lazy" src={femaleIcon} alt="" />
                </div>
                <AnimatedCounter value={figures[3]?.value || 0} suffix="" />
                <Text>{figures[3]?.label}</Text>
              </Card>
            </Col>
          </Row>
        </Col>

        <Col xs={24} md={12}>
          <Card className="progress-card">
            <Title level={4} style={{ marginTop: 0, marginBottom: 30, color: "#0A0A0A" }}>
              {t("keyFigures.progressMeter") || "प्रगती मीटर"}
            </Title>
            {progressData.length === 0 ? (
              <EmptyState description={i18n.language === 'mr' ? 'डेटा लवकरच उपलब्ध होईल' : 'Data will be available soon'} />
            ) : (
              progressData.map((item, index) => (
                <div className="progress-item" key={index}>
                  {index < 2 ? (
                    // First 2 items: Show progress bar with percentage
                    <>
                      <Row justify="space-between" align="middle">
                        <Col>
                          <Text style={{ color: "#212121" }}>{item.label}</Text>
                        </Col>
                        <Col>
                          <Text style={{ color: "#212121" }}>{`${item.percent}%`}</Text>
                        </Col>
                      </Row>
                      <Progress
                        percent={item.percent}
                        showInfo={false}
                        strokeColor={item.strokeColor}
                        strokeWidth={8}
                      />
                    </>
                  ) : (
                    // Last 3 items: Show only value without progress bar or % symbol
                    <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
                      <Col>
                        <Text style={{ color: "#212121" }}>{item.label}</Text>
                      </Col>
                      <Col>
                        <Text style={{ color: "#212121", fontWeight: 600 }}>{item.percent}</Text>
                      </Col>
                    </Row>
                  )}
                </div>
              ))
            )}
          </Card>
        </Col>

        <Col xs={12} sm={12} md={6} lg={6}>
          <Card className="key-figure-card">
            <div
              className="bottom-card-icon-wrapper"
              style={{
                background: "linear-gradient(135deg, #00C950 0%, #006D29 100%)",
              }}
            >
              <img loading="lazy" src={literacyIcon} alt="" />
            </div>
            <AnimatedCounter value={figures[4]?.value || 0} suffix=" %" />
            <Text>{figures[4]?.label}</Text>
          </Card>
        </Col>
        <Col xs={12} sm={12} md={6} lg={6}>
          <Card className="key-figure-card">
            <div
              className="bottom-card-icon-wrapper"
              style={{
                background: "linear-gradient(135deg, #FF6900 0%, #F54900 100%)",
              }}
            >
              <img loading="lazy" src={locationIcon} alt="" />
            </div>
            <AnimatedCounter value={figures[5]?.value || 0} suffix=" हेक्टर" />
            <Text>{figures[5]?.label}</Text>
          </Card>
        </Col>
        <Col xs={24} md={12}>
          <Card className="key-figure-card">
            <div
              className="bottom-card-icon-wrapper"
              style={{
                background: "linear-gradient(135deg, #00B8DB 0%, #004A5D 100%)",
              }}
            >
              <img loading="lazy" src={schoolIcon} alt="" />
            </div>
            <AnimatedCounter value={figures[6]?.value || 0} suffix="" />
            <Text>{figures[6]?.label}</Text>
          </Card>
        </Col>
        <Col xs={12} sm={12} md={6} lg={6}>
          <Card className="key-figure-card">
            <div
              className="bottom-card-icon-wrapper"
              style={{
                background: "linear-gradient(135deg, #B77224 0%, #573000 100%)",
              }}
            >
              <img loading="lazy" src={villageIcon} alt="" />
            </div>
            <AnimatedCounter value={figures[7]?.value || 0} suffix="" />
            <Text>{figures[7]?.label}</Text>
          </Card>
        </Col>
        <Col xs={12} sm={12} md={6} lg={6}>
          <Card className="key-figure-card">
            <div
              className="bottom-card-icon-wrapper"
              style={{
                background: "linear-gradient(135deg, #FF8027 0%, #F54900 100%)",
              }}
            >
              <img loading="lazy" src={societyIcon} alt="" />
            </div>
            <AnimatedCounter value={figures[8]?.value || 0} suffix="" />
            <Text>{figures[8]?.label}</Text>
          </Card>
        </Col>
        <Col xs={12} sm={12} md={6} lg={6}>
          <Card className="key-figure-card">
            <div
              className="bottom-card-icon-wrapper"
              style={{
                background: "linear-gradient(135deg, #00C950 0%, #006D29 100%)",
              }}
            >
              <img loading="lazy" src={healthIcon} alt="" />
            </div>
            <AnimatedCounter value={figures[9]?.value || 0} suffix="" />
            <Text>{figures[9]?.label}</Text>
          </Card>
        </Col>
        <Col xs={12} sm={12} md={6} lg={6}>
          <Card className="key-figure-card">
            <div
              className="bottom-card-icon-wrapper"
              style={{
                background: "linear-gradient(135deg, #2B7FFF 0%, #002371 100%)",
              }}
            >
              <img loading="lazy" src={industryIcon} alt="" />
            </div>
            <AnimatedCounter value={figures[10]?.value || 0} suffix="" />
            <Text>{figures[10]?.label}</Text>
          </Card>
        </Col>
      </Row>

      <div>
        {/* Bottom Section Header */}
        <div
          className="section-header"
          style={{
            width: "fit-content",
            height: 36,
            padding: "8px 16px",
            gap: 8,
            opacity: 1,
            borderRadius: 37170400, // Extremely high, effectively fully rounded
            display: "flex",
            alignItems: "center",
          }}
        >
          <p
            style={{
              margin: 0,
              color: "#212121",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <img
              src={badgeIcon}
              alt="Trophy Icon"
              style={{ width: "20px", height: "20px" }}
            />
            <span>{t("keyFigures.topAchievements")}</span>
          </p>
        </div>

        {/* Bottom Row: Achievements/Information Cards */}
        <div className="grid grid-cols-2 gap-3 md:flex md:flex-row md:gap-2">
          {bottomInfoData.map((item, index) => (
            <Col key={index} style={{ flex: 1, minWidth: 0 }}>
              <Card className="bottom-info-card ">
                <div className="bottom-card-icon-wrapper">{item.icon}</div>
                <p strong style={{ fontSize: "14px", color: "#212121" }}>
                  {item.value}
                </p>
              </Card>
            </Col>
          ))}
        </div>
      </div>
      {/* Decorative bottom image as a real block element so it can be controlled directly */}
      <div className="keyfigure-bottom-img" aria-hidden="true" />
    </div>
  );
};

export default KeyFiguresUi;
